module.exports = __webpack_public_path__ + "img/gas.f12cdbd.svg";